import React, { useEffect, useRef, useState } from "react";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Autocomplete from "@mui/material/Autocomplete";
import Typography from "@mui/material/Typography";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CircularProgress from "@mui/material/CircularProgress";
import {
  MailOutline as MailOutlineIcon,
  ShareLocationRounded as ShareLocationRoundedIcon,
} from "@mui/icons-material";
import { useFormik } from "formik";
import * as Yup from "yup";
import "./employer.css";
import { Data } from "./Data";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import InputAdornment from "@mui/material/InputAdornment";
import logo from "../../../img/logo_for-landingpage-3.png";
import BusinessIcon from "@mui/icons-material/Business";
import {
  FormControl,
  Grid,
  InputLabel,
  Select,
  MenuItem,
  Tooltip,
} from "@mui/material";
import { useNavigate, Outlet } from "react-router";
import useAxios from "../../../api/useAxios";
import { ROUTINGDATA } from "../../ROUTINGDATA";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import Popper from "@mui/material/Popper";

import { useTranslation } from "react-i18next";
import { t } from "i18next";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const theme = createTheme();

const exceptThisSymbols = ["e", "E", "+", "-", ".", "ArrowUp", "ArrowDown"];

function Employer() {
  //  translation
  const { t, i18n, ready } = useTranslation();
  const ref = React.createRef(null);
  const inputRef = useRef(null);
  const axiosData = useAxios();
  const [focusout, setfocus] = useState();
  const [focusNo, setFocusNo] = useState();
  const [emailErr, setEmailError] = useState(true);
  const [valid, setvalid] = useState(true);
  const [pinLoad, setpinLoad] = useState(false);

  const [selectedIndustry, setSelectedIndustry] = useState();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [industryArray, setIndustryArray] = useState();
  const [districtData, setDistrictData] = useState([]);

  const [formEmail, setFormEmail] = useState("");
  const [formEmailError, setFormEmailError] = useState("");

  const [emailPopUp, setEmailPopUp] = useState(false);
  const [mobilePopUp, setMobilePopUp] = useState(false);
  const [comdata, setComdata] = useState([]);

  const navigate = useNavigate();

  const [alertm, setalert] = useState(false);
  const [alerte, setalerte] = useState(false);
  useEffect(() => {
    if (alertm !== false) {
      setMobilePopUp(true);
      formik.setFieldValue("mobile_number", "");
    }
    setalert(false);
  }, [alertm]);
  useEffect(() => {
    if (alerte !== false) {
      setEmailPopUp(true);
      setFormEmail("");
      formik.setFieldValue("email_id", "");
    }
    setalerte(false);
  }, [alerte]);

  useEffect(() => {
    IndustryData();
    vodingDistrict();
  }, []);

  const errors = {};
  const validate = async (values) => {
    const errors = {};

    if (!values.mobile_number) {
      errors.mobile_number = t("Mobile_Number_must_be_Required");
      setvalid(true);
    } else if (/^\d{9}$/.test(values.mobile_number)) {
      setvalid(true);
    } else if (/^\d{10}$/.test(values.mobile_number)) {
      if (valid) {
        const controller = new AbortController();
        try {
          const response = await axiosData.get(
            `users/Mobile/${values.mobile_number}`
          );

          if (response.status === 200) {
            setalert(true);
          } else if (response.status === 204) {
            setalert(false);
          }

          setvalid(false);

          return () => controller.abort();
        } catch (error) {}
      }
    }

    return errors;
  };
  const formik = useFormik({
    initialValues: {
      company_name: "",
      industry: "",
      district: "",
      contact_person: "",
      designation: "",
      email_id: "",
      mobile_number: "",
      company_total_employees: "",
      pincode: "",
    },
    validate,
    validationSchema: Yup.object({
      company_name: Yup.string()
        .max(50, t("Must_be_50_characters_or_less"))
        .required(t("Company_Name_must_be_Required")),
      industry: Yup.string().required(t("Select_Industry2")),
      // district: Yup.string().required(t("Select_District2")),
      company_total_employees: Yup.string().required(
        t("Select_company_total_employees")
      ),
      contact_person: Yup.string()
        .max(50, t("Must_be_50_characters_or_less"))
        .required(t("Contact_person_name_is_required")),
      designation: Yup.string()
        .max(50, t("Must_be_50_characters_or_less"))
        .required(t("Designation_must_be_Required")),
      mobile_number: Yup.number()
        .min(6000000000, t("Not_Valid_Mobile_Number!"))
        .max(9999999999, t("Not_Valid_Mobile_Number!"))
        .required(t("Mobile_Number_must_be_Required2")),
      // pincode: Yup.string().required(t("pincode_is_Required")),
    }),

    onSubmit: (values) => {
      // const pincodeSplit = values.pincode.split("/");
      // const [a, b] = pincodeSplit;
      // values.pincode = a;
      // values.area = b;

      values.email_id = formEmail;
      setIsSubmitting(true);
      Apifetch(values);
    },
  });
  const handleChange = (e) => {
    setFocusNo(false);
    const { value } = e.target;
    if (value.length <= 10) {
      formik.handleChange(e);
    }
  };

  const Apifetch = (data) => {
    console.log("datass", data);
    axiosData
      .post("employers", data)
      .then((res) => {
        axiosData
          .post(
            "users",
            {
              usertype: "provider",
              status: "InActive",
              uniqueId: data.mobile_number,
              password: data.mobile_number,
              email_id: data.email_id,
              user_id: res.data.user_id,
            },
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          )
          .then((res) => {});
        setIsSubmitting(false);
        navigate(
          `${ROUTINGDATA.LAND}${ROUTINGDATA.MAIN}${ROUTINGDATA.ThankYou}`
        );
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };
  const IndustryData = async () => {
    try {
      const getOneAxios = await axiosData.get(`/General/seekerSettings`);
      const data = getOneAxios?.data?.industryData;
      if (data) {
        setIndustryArray(data);
      }
      return data;
    } catch (err) {
      console.log("Error", err);
    }
  };
  const vodingDistrict = async () => {
    try {
      const getOneAxios = await axiosData.get(`/district`);
      const data = getOneAxios.data;
      if (data) {
        const getDistrict = data.map((i) => {
          return i.District;
        });
        getDistrict.sort();
        setDistrictData(getDistrict);
      }
      return data;
    } catch (err) {
      console.log("Error", err);
    }
  };
  const searchobj = async (values) => {
    // setAdDistrict(values);
    setpinLoad(true);
    try {
      const getOneAxiospin = await axiosData.get(
        `/distritarea/getArea/${values}`
      );
      const datapin = getOneAxiospin.data;
      if (datapin) {
        const getpin = datapin.map((i) => {
          return i.Pincode;
        });
        const getpost = datapin.map((i) => {
          return i.Post_Office;
        });
        const getpost1 = getpost[0];
        const result = getpin[0].reduce(
          (accumulator, currentPincode, index) => {
            return accumulator.concat(`${currentPincode}/${getpost1[index]}`);
          },
          []
        );
        const getPostFinal = result.map((i) => {
          return i;
        });
        // setPincodeData(getpin[0]);
        // setPostOfficeData(getpost[0]);
        // setPincode(datapin);
        setComdata([...getPostFinal]);
        setpinLoad(false);
      }
      // return data;
    } catch (err) {
      console.log("Error", err);
    }
  };
  const filterOptions = (options, { inputValue }) => {
    const inputValueLower = inputValue.toLowerCase();
    const startsWithInput = [];
    const containsInput = [];

    options.forEach((option) => {
      const optionLower = option.toLowerCase();
      if (optionLower.startsWith(inputValueLower)) {
        startsWithInput.push(option);
      } else if (optionLower.includes(inputValueLower)) {
        containsInput.push(option);
      }
    });

    return [...startsWithInput, ...containsInput];
  };

  const handleEmailBlur = () => {
    if (!formEmail) {
      setFormEmailError(t("EmailId_must_be_Required"));
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formEmail)) {
      setFormEmailError(t("Invalid_email_format"));
    } else {
      setFormEmailError("");
    }
  };

  const handleEmailChange = async (event) => {
    const email_id = event.target.value.replace(/[^a-z0-9@.]/gi, "");
    setFormEmail(email_id);
    if (!email_id) {
      setfocus(true);
      setFormEmailError(t("EmailId_must_be_Required"));
      errors.email_id = t("EmailId_must_be_Required");
      setEmailError(true);
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email_id)) {
      setfocus(false);
      setFormEmailError(t("Invalid_email_address"));
      errors.email_id = t("Invalid_email_address");
    } else if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email_id)) {
      setEmailError(true);
      setFormEmailError("");
      if (emailErr) {
        try {
          const response = await axiosData.post(`users/email`, {
            email_id: email_id,
          });
          if (response.status === 200) {
            setalerte(true);
            formik.setFieldValue("email_id", event.target.value);
          }
        } catch (error) {}
      }
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{3,}$/i.test(email_id)) {
      errors.email_id = "Invalid email address";
    } else if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{3,}$/i.test(email_id)) {
      setEmailError(true);
      if (emailErr) {
        try {
          const response = await axiosData.post(`users/email`, {
            email_id: email_id,
          });
          if (response.status === 200) {
            setalerte(true);
          }
        } catch (error) {
          console.log(error);
        }
      }
    }
  };

  const lang = localStorage.getItem("lang");

  if (ready) {
    return (
      <ThemeProvider theme={theme}>
        <Dialog TransitionComponent={Transition} open={emailPopUp}>
          <DialogTitle
            bgcolor="rgb(16 143 178)"
            sx={{ color: "white", fontWeight: 600 }}
          >
            {t("Email_Exits")}
          </DialogTitle>
          <DialogContent sx={{ mt: 3 }}>
            <DialogContentText sx={{ fontWeight: 600 }}>
              {t("This_Email_Id_already_exist")}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              color="primary"
              variant="contained"
              onClick={() => setEmailPopUp(false)}
            >
              {t("Ok")}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog TransitionComponent={Transition} open={mobilePopUp}>
          <DialogTitle
            bgcolor="rgb(16 143 178)"
            sx={{ color: "white", fontWeight: 600 }}
          >
            {t("Mobile_Number_Exits")}
          </DialogTitle>
          <DialogContent sx={{ mt: 3 }}>
            <DialogContentText sx={{ fontWeight: 600 }}>
              {t("This_Mobile_number_already_exist")}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              color="primary"
              variant="contained"
              onClick={() => setMobilePopUp(false)}
            >
              {t("Ok")}
            </Button>
          </DialogActions>
        </Dialog>

        <Grid
          container
          component="main"
          sx={{ height: "100vh" }}
          className="main-grid"
        >
          <CssBaseline />
          <Grid className="img-grid" item xs={false} sm={false} md={4}>
            <Box className="sideimg">
              <div className="sideimglogo">
                <img src={logo} alt="logo" style={{ width: "75%" }} />
              </div>
              <div className="sidecontect">
                <Typography
                  variant="h6"
                  className={lang === "tamil" ? "side-tamil-1" : "side-english"}
                  gutterBottom
                >
                  {t("Side_Content2")}
                </Typography>
                <div className="listofsidecontect">
                  <div>
                    <CheckCircleIcon sx={{ color: "green" }} />
                  </div>
                  <div
                    className={lang === "tamil" ? "side-tamil" : "side-english"}
                  >
                    {t("Build_Your_Company2")}
                  </div>
                </div>
                <div className="listofsidecontect">
                  <div>
                    <CheckCircleIcon sx={{ color: "green" }} />
                  </div>
                  <div
                    className={lang === "tamil" ? "side-tamil" : "side-english"}
                  >
                    {t("Hire_Employees")}
                  </div>
                </div>
                <div className="listofsidecontect">
                  <div>
                    <CheckCircleIcon sx={{ color: "green" }} />
                  </div>
                  <div
                    className={lang === "tamil" ? "side-tamil" : "side-english"}
                  >
                    {t("Find_Your_Employers")}
                  </div>
                </div>
              </div>
            </Box>
          </Grid>
          <Grid
            className="second-grid"
            item
            xs={12}
            sm={12}
            md={8}
            component={Paper}
            elevation={4}
            square
          >
            <form onSubmit={formik.handleSubmit}>
              <Box
                sx={{
                  my: 3,
                  mx: 8,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <BusinessIcon
                  sx={{ mb: 2, width: 56, height: 56, color: "#ed1e70" }}
                />

                <Typography
                  component="h1"
                  variant="h5"
                  sx={{ color: "#135c82" }}
                >
                  {t("Employer_Registration")}
                </Typography>

                <Box sx={{ mt: 1 }}>
                  <Grid container rowSpacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        required
                        margin="normal"
                        fullWidth
                        placeholder={t("Enter_Your_Company_Name")}
                        id="company_name"
                        label={t("Company_Name")}
                        name="company_name"
                        onBlur={formik.handleBlur}
                        onChange={(e) => {
                          if (e) {
                            const value = e.target.value.replace(
                              /[^a-z0-9()&@ .$#_-]/gi,
                              ""
                            );
                            formik.setFieldValue("company_name", value);
                          }
                        }}
                        value={formik.values.company_name}
                      />
                      {formik.touched.company_name &&
                      formik.errors.company_name ? (
                        <div style={{ color: "red" }}>
                          {formik.errors.company_name}
                        </div>
                      ) : null}
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        margin="normal"
                        fullWidth
                        required
                        placeholder={t("Enter_Your_Email_ID2")}
                        id="email_id"
                        label={t("Email_Id2")}
                        name="formEmail"
                        onBlur={handleEmailBlur}
                        ref={ref}
                        onBlurCapture={() => {
                          setfocus(true);
                        }}
                        onChange={handleEmailChange}
                        value={formEmail}
                        InputLabelProps={{
                          style: { color: "black" },
                        }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <MailOutlineIcon />{" "}
                            </InputAdornment>
                          ),
                        }}
                      />
                      {formEmailError && focusout ? (
                        <div style={{ color: "red" }}>{formEmailError}</div>
                      ) : null}
                    </Grid>
                    <Grid item xs={12}>
                      {industryArray && (
                        <FormControl sx={{ mt: 1, mb: 1 }} fullWidth required>
                          <Autocomplete
                            disableClearable={
                              formik.values.industry ? false : true
                            }
                            filterOptions={filterOptions}
                            id="industry"
                            name="industry"
                            options={industryArray}
                            onBlur={formik.handleBlur}
                            onChange={(event, value) => {
                              setSelectedIndustry(value);
                              formik.setFieldValue("industry", value);
                            }}
                            value={formik.values.industry}
                            renderInput={(params) => (
                              <TextField
                                required
                                {...params}
                                id="industry"
                                label={t("Preffered_Industry2")}
                                name="industry"
                                // onClick={() => params.inputProps.onInputClick()}
                              />
                            )}
                            onOpen={(event) => event.preventDefault()}
                            PopperComponent={({ children, ...popperProps }) => (
                              <Popper
                                {...popperProps}
                                placement="bottom-start"
                                modifiers={{
                                  flip: {
                                    enabled: false,
                                  },
                                  preventOverflow: {
                                    enabled: true,
                                    boundariesElement: "scrollParent",
                                  },
                                }}
                                PopperProps={{
                                  placement: "bottom-start", // Placement set to "bottom-start"
                                }}
                              >
                                <Paper>{children}</Paper>
                              </Popper>
                            )}
                            ListboxProps={{
                              style: { maxHeight: "180px", overflowY: "auto" },
                            }}
                          />
                          {formik.touched.industry && formik.errors.industry ? (
                            <div style={{ color: "red" }}>
                              {formik.errors.industry}
                            </div>
                          ) : null}
                        </FormControl>
                      )}
                    </Grid>

                    {/* <Grid item xs={12} sx={{ marginTop: 1 }}>
                      <FormControl fullWidth required>
                        <Autocomplete
                          disableClearable={
                            formik.values.district ? false : true
                          }
                          fullWidth
                          filterOptions={filterOptions}
                          name="district"
                          id="district"
                          value={formik.values.district}
                          onChange={(event, value) => {
                            formik.setFieldValue("district", value);
                            searchobj(value);
                            formik.setFieldValue("pincode", "");
                          }}
                          onBlur={formik.handleBlur}
                          options={districtData}
                          getOptionLabel={(option) => option}
                          renderInput={(params) => (
                            <TextField
                              required
                              {...params}
                              label={t("District")}
                              //onClick={() => params.inputProps.onInputClick()}
                              InputLabelProps={{
                                style: { marginLeft: "7px" },
                              }}
                            />
                          )}
                          onOpen={(event) => event.preventDefault()}
                          PopperComponent={({ children, ...popperProps }) => (
                            <Popper
                              {...popperProps}
                              placement="bottom-start"
                              modifiers={{
                                flip: {
                                  enabled: false,
                                },
                                preventOverflow: {
                                  enabled: true,
                                  boundariesElement: "scrollParent",
                                },
                              }}
                              PopperProps={{
                                placement: "bottom-start", // Placement set to "bottom-start"
                              }}
                            >
                              <Paper>{children}</Paper>
                            </Popper>
                          )}
                          ListboxProps={{
                            style: { maxHeight: "180px", overflowY: "auto" },
                          }}
                        />
                        {formik.touched.district && formik.errors.district ? (
                          <div style={{ color: "red" }}>
                            {formik.errors.district}
                          </div>
                        ) : null}
                      </FormControl>
                    </Grid> */}
                    {/* <Grid item xs={12}>
                      <Tooltip
                        title={
                          formik.values.district ? "" : "please select District"
                        }
                      >
                        <FormControl fullWidth required sx={{ marginY: 2 }}>
                          <Autocomplete
                            disableClearable={
                              formik.values.pincode ? false : true
                            }
                            disablePortal
                            freeSolo
                            disabled={
                              formik.values.district && !pinLoad ? false : true
                            }
                            id="pincode"
                            name="pincode"
                            options={comdata}
                            value={formik.values.pincode}
                            onChange={(event, value) => {
                              formik.setFieldValue("pincode", value);
                            }}
                            onBlur={formik.handleBlur}
                            renderInput={(params) => (
                              <TextField
                                required
                                // onChange={formik.handleChange}
                                {...params}
                                label={t("Pincode")}
                                InputProps={{
                                  ...params.InputProps,
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      {pinLoad ? (
                                        <CircularProgress
                                          // size={24}
                                          style={{
                                            width: "1.4rem",
                                            height: "1.4rem",
                                            color: "#4991dd",
                                          }}
                                        />
                                      ) : (
                                        <ShareLocationRoundedIcon
                                          sx={{
                                            color: formik.values.district
                                              ? "#414141"
                                              : "#bdbdbd",
                                          }}
                                        />
                                      )}{" "}
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            )}
                          /> */}

                          {/* <TextField
                        margin="normal"
                        fullWidth
                        name="pincode"
                        label={t("Pincode")}
                        type="Number"
                        id="pincode"
                        onWheel={(e) => {
                          e.preventDefault();
                          e.target.blur();
                        }}
                        onKeyDown={(e) =>
                          exceptThisSymbols.includes(e.key) &&
                          e.preventDefault()
                        }
                        onBlurCapture={() => {
                          setFocusPin(true);
                        }}
                        placeholder={t("Enter_Pincode(Optional)")}
                        onBlur={formik.handleBlur}
                        onChange={handleChangePincode}
                        value={formik.values.pincode}
                      /> */}
                          {/* {formik.touched.pincode && formik.errors.pincode ? (
                            <div style={{ color: "red" }}>
                              {formik.errors.pincode}
                            </div>
                          ) : null}
                        </FormControl>
                      </Tooltip>
                    </Grid> */}
                    <Grid item xs={12}>
                      <FormControl fullWidth required>
                        <InputLabel id="demo-simple-select-label">
                          {t("company_total_employees")}
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          name="company_total_employees"
                          value={formik.values.company_total_employees}
                          label={t("company_total_employees")}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        >
                          <MenuItem value={"1 to 50"}>1 to 50</MenuItem>
                          <MenuItem value={"51 to 150"}>51 to 150</MenuItem>
                          <MenuItem value={"151 to 250"}>151 to 250</MenuItem>
                          <MenuItem value={"251 to 500"}>251 to 500</MenuItem>
                          <MenuItem value={"501 to 750"}>501 to 750</MenuItem>
                          <MenuItem value={"751 to 900"}>751 to 900</MenuItem>
                          <MenuItem value={"901 to 1000"}>901 to 1000</MenuItem>
                          <MenuItem value={"1001+"}>1001+</MenuItem>
                        </Select>
                      </FormControl>
                      {formik.touched.company_total_employees &&
                      formik.errors.company_total_employees ? (
                        <div style={{ color: "red" }}>
                          {formik.errors.company_total_employees}
                        </div>
                      ) : null}
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        required
                        margin="normal"
                        fullWidth
                        placeholder={t("Enter_Your_Contact_Person_Name")}
                        id="contact_person"
                        label={t("Contact_Person_Name")}
                        name="contact_person"
                        onBlur={formik.handleBlur}
                        onChange={(e) => {
                          if (e) {
                            const value = e.target.value.replace(
                              /[^a-z'. ]/gi,
                              ""
                            );
                            formik.setFieldValue("contact_person", value);
                          }
                        }}
                        value={formik.values.contact_person}
                      />
                      {formik.touched.contact_person &&
                      formik.errors.contact_person ? (
                        <div style={{ color: "red" }}>
                          {formik.errors.contact_person}
                        </div>
                      ) : null}
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        required
                        margin="normal"
                        fullWidth
                        placeholder={t("Enter_Your_Designation")}
                        id="designation"
                        label={t("Designation")}
                        name="designation"
                        onBlur={formik.handleBlur}
                        onChange={(e) => {
                          if (e) {
                            const value = e.target.value.replace(
                              /[^a-z'. ]/gi,
                              ""
                            );
                            formik.setFieldValue("designation", value);
                          }
                        }}
                        value={formik.values.designation}
                      />
                      {formik.touched.designation &&
                      formik.errors.designation ? (
                        <div style={{ color: "red" }}>
                          {formik.errors.designation}
                        </div>
                      ) : null}
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        required
                        margin="normal"
                        fullWidth
                        ref={inputRef}
                        placeholder={t("Enter_Your_Mobile_Number2")}
                        name="mobile_number"
                        label={t("Mobile_Number2")}
                        type="Number"
                        id="mobile_number"
                        onBlur={formik.handleBlur}
                        onChange={handleChange}
                        onBlurCapture={() => {
                          setFocusNo(true);
                        }}
                        onKeyDown={(e) =>
                          exceptThisSymbols.includes(e.key) &&
                          e.preventDefault()
                        }
                        onWheel={(e) => {
                          e.preventDefault();
                          e.target.blur();
                        }}
                        value={formik.values.mobile_number}
                        InputLabelProps={{
                          style: { color: "black" },
                        }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <b>+91</b>
                            </InputAdornment>
                          ),
                        }}
                      />
                      {formik.touched.mobile_number &&
                      formik.errors.mobile_number &&
                      focusNo ? (
                        <div style={{ color: "red" }}>
                          {formik.errors.mobile_number}
                        </div>
                      ) : null}
                    </Grid>

                    <Button
                      type="submit"
                      fullWidth
                      variant="contained"
                      sx={{ mt: 3, mb: 2 }}
                      disabled={
                        !formEmailError &&
                        formik.isValid &&
                        formik.dirty &&
                        isSubmitting === false
                          ? false
                          : true
                      }
                    >
                      {t("Submit2")}
                      {isSubmitting && (
                        <CircularProgress
                          size={24}
                          sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            marginTop: "-12px",
                            marginLeft: "-12px",
                          }}
                        />
                      )}
                    </Button>
                  </Grid>
                </Box>
              </Box>
            </form>
          </Grid>
        </Grid>
        <Outlet />
      </ThemeProvider>
    );
  } else {
    return (
      <div
        style={{
          height: "70vh",
          display: "grid",
          placeItems: "center",
        }}
      >
        <div class="dots"></div>
      </div>
    );
  }
}
export default Employer;
